module.exports = __webpack_public_path__ + "img/index-preview.a06a86dc.svg";